module.exports = __webpack_public_path__ + "img/ios-print.4a677416.svg";